import { IMessagesResponseError } from '../../repositories/chats/v2/messages';
import { TMessageSchema } from '../../types/messages';
import { ITypedReduxAction } from '../../types/redux/actionType';

export interface IMessagesState {
  unreadCount: number;
}

export interface IMessagesReadResponse {
  chatId: string;
  messageIds: string[];
}

export type TMessageListPayload = {
  messages: TMessageSchema[];
};

export type TMessagesErrorPayload = {
  chatId: string;
  error: IMessagesResponseError;
};

export enum EMessagesActionTypes {
  SetAsRead = 'messages/set-as-read',
  SetMessagesPending = 'messages/pending',
  SetMessagesFulfilled = 'messages/fulfilled',
  SetMessagesFailed = 'messages/failed',
}

export type TMessagesActions =
  | ITypedReduxAction<EMessagesActionTypes.SetAsRead, IMessagesReadResponse>
  | ITypedReduxAction<EMessagesActionTypes.SetMessagesPending, { chatId: string }>
  | ITypedReduxAction<EMessagesActionTypes.SetMessagesFulfilled, TMessageListPayload>
  | ITypedReduxAction<EMessagesActionTypes.SetMessagesFailed, TMessagesErrorPayload>;
